var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_72_6283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.18071 2.34439C9.21642 2.15323 9.31786 1.98057 9.46746 1.85632C9.61706 1.73208 9.80541 1.66406 9.99988 1.66406C10.1943 1.66406 10.3827 1.73208 10.5323 1.85632C10.6819 1.98057 10.7833 2.15323 10.819 2.34439L11.6949 6.97606C11.7571 7.30535 11.9171 7.60824 12.1541 7.8452C12.391 8.08216 12.6939 8.24219 13.0232 8.30439L17.6549 9.18022C17.846 9.21593 18.0187 9.31737 18.1429 9.46697C18.2672 9.61658 18.3352 9.80492 18.3352 9.99939C18.3352 10.1939 18.2672 10.3822 18.1429 10.5318C18.0187 10.6814 17.846 10.7829 17.6549 10.8186L13.0232 11.6944C12.6939 11.7566 12.391 11.9166 12.1541 12.1536C11.9171 12.3905 11.7571 12.6934 11.6949 13.0227L10.819 17.6544C10.7833 17.8456 10.6819 18.0182 10.5323 18.1425C10.3827 18.2667 10.1943 18.3347 9.99988 18.3347C9.80541 18.3347 9.61706 18.2667 9.46746 18.1425C9.31786 18.0182 9.21642 17.8456 9.18071 17.6544L8.30488 13.0227C8.24267 12.6934 8.08265 12.3905 7.84569 12.1536C7.60873 11.9166 7.30584 11.7566 6.97655 11.6944L2.34488 10.8186C2.15372 10.7829 1.98106 10.6814 1.85681 10.5318C1.73256 10.3822 1.66455 10.1939 1.66455 9.99939C1.66455 9.80492 1.73256 9.61658 1.85681 9.46697C1.98106 9.31737 2.15372 9.21593 2.34488 9.18022L6.97655 8.30439C7.30584 8.24219 7.60873 8.08216 7.84569 7.8452C8.08265 7.60824 8.24267 7.30535 8.30488 6.97606L9.18071 2.34439Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6665 1.66602V4.99935",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 3.33398H15",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33317 18.3333C4.25365 18.3333 4.99984 17.5871 4.99984 16.6667C4.99984 15.7462 4.25365 15 3.33317 15C2.4127 15 1.6665 15.7462 1.6665 16.6667C1.6665 17.5871 2.4127 18.3333 3.33317 18.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_72_6283"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.50274d2263c7680dbb6c1d9178086959.svg";
export { ForwardRef as ReactComponent };